<div class="department-page" [attr.dir]="dir" (click)="closeAllMenus()">

  <header class="page-hero">
    <div class="page-hero__text">
      <h1 class="page-hero__title">{{ 'Department' | navTitle | async }}</h1>
      <p class="page-hero__subtitle">
        {{ dir === 'rtl'
          ? 'إدارة الإدارات والأقسام، واختيار إدارة لعرض أقسامها.'
          : 'Manage departments and sections, then select a department to view its sections.' }}
      </p>
    </div>
    <button type="button" class="btn-add" (click)="openDepartmentModal(0)">
      <i class="fa-solid fa-plus"></i>
      <span>{{ 'add' | translate }}</span>
    </button>
  </header>

  <section class="stats-grid" aria-label="summary">
    <div class="stat-chip">
      <span class="stat-chip__value">{{ departments.length }}</span>
      <span class="stat-chip__label">{{ 'departments_offices' | translate }}</span>
    </div>
    <div class="stat-chip">
      <span class="stat-chip__value">{{ getTotalSectionsCount() }}</span>
      <span class="stat-chip__label">{{ 'sections' | translate }}</span>
    </div>
    <div class="stat-chip">
      <span class="stat-chip__value">{{ getAssignedManagersCount() }}</span>
      <span class="stat-chip__label">{{ dir === 'rtl' ? 'بمسؤول' : 'With manager' }}</span>
    </div>
    <div class="stat-chip">
      <span class="stat-chip__value">{{ filteredDepartments.length }}</span>
      <span class="stat-chip__label">{{ dir === 'rtl' ? 'معروضة' : 'Shown' }}</span>
    </div>
  </section>

  <section class="toolbar-card">
    <div class="search-wrapper">
      <i class="fa-solid fa-magnifying-glass search-icon"></i>
      <input
        type="search"
        class="search-input"
        [(ngModel)]="searchTerm"
        (input)="onSearch()"
        [placeholder]="dir === 'rtl' ? 'ابحث باسم الإدارة أو المسؤول...' : 'Search by department or manager...'" />
      @if (searchTerm) {
        <button type="button" class="search-clear" (click)="clearSearch()">
          <i class="fa-solid fa-xmark"></i>
        </button>
      }
    </div>
  </section>

  <section class="results-card">
    <div class="results-header">
      <h2 class="results-title">
        <i class="fa-solid fa-building"></i>
        {{ 'departments_offices' | translate }}
      </h2>
      <span class="results-hint">
        {{ dir === 'rtl' ? 'اختر إدارة لعرض أقسامها بالأسفل' : 'Select a department to view its sections below' }}
      </span>
    </div>

    @if (!filteredDepartments.length) {
      <div class="empty-state">
        <div class="empty-state__icon"><i class="fa-solid fa-building"></i></div>
        <p class="empty-state__title">{{ 'no_departments_found' | translate }}</p>
        <p class="empty-state__text">{{ 'click_add_button_to_create_department' | translate }}</p>
      </div>
    } @else {
      <div class="departments-grid">
        @for (department of filteredDepartments; track department.id; let i = $index) {
          <article
            class="department-card"
            [class.is-selected]="selectedDepartmentId === department.id"
            (click)="$event.stopPropagation()">

            <div class="department-menu-container">
              <button type="button" class="menu-dots-btn" (click)="toggleMenu($event, department.id || 0)">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </button>
              @if (activeMenuId === department.id) {
                <div class="menu-dropdown" (click)="$event.stopPropagation()">
                  <button type="button" class="menu-item menu-edit" (click)="openDepartmentModal(department.id || 0); closeMenu()">
                    <i class="fa-solid fa-pen-to-square"></i>
                    <span>{{ 'edit' | translate }}</span>
                  </button>
                  <button type="button" class="menu-item menu-delete" (click)="openDeleteDepartmentModal(department.id || 0); closeMenu()">
                    <i class="fa-regular fa-trash-can"></i>
                    <span>{{ 'delete' | translate }}</span>
                  </button>
                </div>
              }
            </div>

            <div class="department-card-header">
              <span class="dept-avatar"><i class="fa-solid fa-building"></i></span>
              <div class="dept-heading">
                <h3 class="department-name">{{ department.name }}</h3>
                @if (selectedDepartmentId === department.id) {
                  <span class="selected-pill">{{ 'selected' | translate }}</span>
                }
              </div>
            </div>

            <div class="department-card-body">
              <div class="department-info-item">
                <i class="fa-solid fa-user-tie info-icon"></i>
                <div class="info-content">
                  <span class="info-label">{{ 'Manager' | translate }}</span>
                  <span class="info-value">
                    @if (department.in_charge_name) {
                      {{ department.in_charge_name }}
                    } @else {
                      {{ 'no_department_head_assigned' | translate }}
                    }
                  </span>
                </div>
              </div>
              <div class="department-info-item">
                <i class="fa-solid fa-sitemap info-icon"></i>
                <div class="info-content">
                  <span class="info-label">{{ 'sections' | translate }}</span>
                  <span class="info-value">{{ department.sections?.length || 0 }} {{ 'section' | translate }}</span>
                </div>
              </div>
            </div>

            <div class="card-footer">
              <button
                type="button"
                class="select-department-btn"
                [class.selected]="selectedDepartmentId === department.id"
                (click)="selectDepartment(department.id || 0)">
                <i class="fa-solid" [ngClass]="selectedDepartmentId === department.id ? 'fa-check-circle' : 'fa-circle'"></i>
                <span>{{ selectedDepartmentId === department.id ? ('selected' | translate) : ('select' | translate) }}</span>
              </button>
            </div>
          </article>
        }
      </div>
    }
  </section>

  @if (selectedDepartmentId > 0) {
    <section class="results-card sections-card" id="sections-panel">
      <div class="results-header">
        <h2 class="results-title">
          <i class="fa-solid fa-sitemap"></i>
          {{ 'sections' | translate }} — {{ selectedDepartment?.name }}
        </h2>
      </div>
      <app-section
        [departmentOptions]="departmentOptions"
        [selectedDepartmentId]="selectedDepartmentId"
        [selectedDepartment]="selectedDepartment"
        [sections]="selectedDepartment?.sections || []">
      </app-section>
    </section>
  }

</div>

<!-- Add/Edit Department Modal -->
@if (isModalVisible) {
  <div class="dept-modal-wrapper" role="presentation">
    <div class="dept-modal-overlay" (click)="closeDepartmentModal()"></div>
    <div class="dept-modal" role="dialog" aria-modal="true"
         [attr.aria-label]="selectedDepartmentModal.id > 0
           ? (dir === 'rtl' ? 'تعديل إدارة' : 'Edit department')
           : (dir === 'rtl' ? 'إضافة إدارة' : 'Add department')">
      <header class="dept-modal__header">
        <div class="dept-modal__title-wrap">
          <span class="dept-modal__icon" [class.dept-modal__icon--edit]="selectedDepartmentModal.id > 0">
            <i class="fa-solid" [ngClass]="selectedDepartmentModal.id > 0 ? 'fa-pen-to-square' : 'fa-building'"></i>
          </span>
          <div class="dept-modal__titles">
            <h2 class="dept-modal__title">
              {{ selectedDepartmentModal.id > 0
                ? (dir === 'rtl' ? 'تعديل إدارة' : 'Edit department')
                : (dir === 'rtl' ? 'إضافة إدارة جديدة' : 'Add new department') }}
            </h2>
            <p class="dept-modal__subtitle">
              {{ selectedDepartmentModal.id > 0
                ? (dir === 'rtl' ? 'حدّث اسم الإدارة ومسؤولها.' : 'Update the department name and manager.')
                : (dir === 'rtl' ? 'أدخل اسم الإدارة وعيّن المسؤول إن وُجد.' : 'Enter the department name and optionally assign a manager.') }}
            </p>
          </div>
        </div>
        <button type="button" class="dept-modal__close" (click)="closeDepartmentModal()"
                [attr.aria-label]="dir === 'rtl' ? 'إغلاق' : 'Close'">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </header>

      <div class="dept-modal__body">
        <form class="dept-form" #departmentForm="ngForm" (ngSubmit)="submit()">
          <div class="dept-form__field">
            <label class="dept-form__label" for="dept-name">
              <i class="fa-solid fa-building"></i>
              <span>{{ 'name' | translate }}</span>
            </label>
            <input
              type="text"
              id="dept-name"
              class="dept-form__input"
              pInputText
              [(ngModel)]="selectedDepartmentModal.name"
              name="name"
              required
              [placeholder]="'enter_department_name' | translate" />
            @if (isModalSubmitted && !selectedDepartmentModal.name) {
              <span class="dept-form__error">
                <i class="fa-solid fa-circle-exclamation"></i>
                {{ 'name_required' | translate }}
              </span>
            }
          </div>

          <div class="dept-form__field">
            <label class="dept-form__label" for="dept-manager">
              <i class="fa-solid fa-user-tie"></i>
              <span>{{ 'Manager' | translate }}</span>
            </label>
            <p-dropdown
              inputId="dept-manager"
              appendTo="body"
              [baseZIndex]="1400"
              panelStyleClass="dept-dropdown-panel"
              styleClass="dept-form-dropdown"
              [(ngModel)]="selectedDepartmentModal.in_charge_id"
              [options]="userOptions"
              optionLabel="label"
              optionValue="id"
              name="in_charge_id"
              [filter]="true"
              filterBy="label"
              [showClear]="true"
              [placeholder]="dir === 'rtl' ? 'اختر المسؤول' : 'Select manager'"
              [filterPlaceholder]="dir === 'rtl' ? 'بحث...' : 'Search...'"
              [emptyMessage]="dir === 'rtl' ? 'لا توجد نتائج' : 'No results found'"
              [emptyFilterMessage]="dir === 'rtl' ? 'لا توجد نتائج' : 'No results found'" />
          </div>

          <div class="dept-form__actions">
            <button type="button" class="dept-btn dept-btn--ghost" (click)="closeDepartmentModal()">
              {{ 'cancel' | translate }}
            </button>
            <button type="submit" class="dept-btn dept-btn--primary">
              <i class="fa-solid" [ngClass]="selectedDepartmentModal.id > 0 ? 'fa-floppy-disk' : 'fa-plus'"></i>
              <span>{{ 'save' | translate }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
}

<!-- Delete Department Modal -->
@if (isDeleteDepartmentModalVisible) {
  <div class="dept-modal-wrapper" role="presentation">
    <div class="dept-modal-overlay" (click)="closeDeleteModal()"></div>
    <div class="dept-modal dept-modal--wide" role="dialog" aria-modal="true">
      <header class="dept-modal__header dept-modal__header--danger">
        <div class="dept-modal__title-wrap">
          <span class="dept-modal__icon dept-modal__icon--danger">
            <i class="fa-solid fa-triangle-exclamation"></i>
          </span>
          <div class="dept-modal__titles">
            <h2 class="dept-modal__title">{{ 'delete_department' | translate }}</h2>
            <p class="dept-modal__subtitle">
              {{ dir === 'rtl'
                ? 'أكمل نقل البيانات المرتبطة قبل الحذف النهائي.'
                : 'Transfer related data before final deletion.' }}
            </p>
          </div>
        </div>
        <button type="button" class="dept-modal__close" (click)="closeDeleteModal()"
                [attr.aria-label]="dir === 'rtl' ? 'إغلاق' : 'Close'">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </header>

      <div class="dept-modal__body">
        @if (!isEmployeeDeletable) {
          <div class="warning-section">
            <div class="warning-message">
              <i class="fa-solid fa-circle-info"></i>
              <p>{{ 'transfer_projects_before_delete' | translate }}</p>
            </div>

            <form [formGroup]="unitProjectsForm" (ngSubmit)="onProjectTransferSubmit()">
              <div class="transfer-projects-section">
                <h4>{{ 'projects_to_transfer' | translate }}</h4>
                @for (project of unitProjects; track project.id; let i = $index) {
                  <div class="project-transfer-item" [formGroupName]="i">
                    <div class="project-info">
                      <strong>{{ project.name }}</strong>
                      <span>{{ project.strategy_name }}</span>
                    </div>
                    <div class="transfer-controls">
                      <p-dropdown
                        [formControlName]="'entity_in_charge_id'"
                        appendTo="body"
                        [baseZIndex]="1400"
                        panelStyleClass="dept-dropdown-panel"
                        styleClass="dept-form-dropdown"
                        [options]="project.entitiesInCharge"
                        optionLabel="name"
                        optionValue="key"
                        [placeholder]="'select_unit' | translate">
                      </p-dropdown>
                      <p-dropdown
                        [formControlName]="'executive_in_charge_id'"
                        appendTo="body"
                        [baseZIndex]="1400"
                        panelStyleClass="dept-dropdown-panel"
                        styleClass="dept-form-dropdown"
                        [options]="project.filteredInChargeExecutives"
                        optionLabel="name"
                        optionValue="id"
                        [placeholder]="'select_executive' | translate">
                      </p-dropdown>
                    </div>
                  </div>
                }
              </div>
              <button type="submit" class="dept-btn dept-btn--primary submit-transfer-btn">
                <i class="fa-solid fa-right-left"></i>
                <span>{{ 'transfer_projects' | translate }}</span>
              </button>
            </form>
          </div>
        }

        @if (isEmployeeDeletable && employees.length > 0) {
          <div class="warning-section">
            <div class="warning-message">
              <i class="fa-solid fa-circle-info"></i>
              <p>{{ 'transfer_employees_before_delete' | translate }}</p>
            </div>

            <form [formGroup]="employeeForm" (ngSubmit)="onEmployeeTransferSubmit()">
              <div class="transfer-employees-section">
                <h4>{{ 'employees_to_transfer' | translate }}</h4>
                @for (employee of employees; track employee.id; let i = $index) {
                  <div class="employee-transfer-item" [formGroupName]="i">
                    <div class="employee-info">
                      <strong>{{ employee.name }}</strong>
                      <span>{{ employee.username }}</span>
                    </div>
                    <div class="transfer-controls">
                      <p-dropdown
                        [formControlName]="'department_id'"
                        appendTo="body"
                        [baseZIndex]="1400"
                        panelStyleClass="dept-dropdown-panel"
                        styleClass="dept-form-dropdown"
                        [options]="employee.departments"
                        optionLabel="name"
                        optionValue="id"
                        [placeholder]="'select_department' | translate">
                      </p-dropdown>
                      <p-dropdown
                        [formControlName]="'section_id'"
                        appendTo="body"
                        [baseZIndex]="1400"
                        panelStyleClass="dept-dropdown-panel"
                        styleClass="dept-form-dropdown"
                        [options]="employee.filterdSections"
                        optionLabel="name"
                        optionValue="id"
                        [placeholder]="'select_section' | translate">
                      </p-dropdown>
                      <p-dropdown
                        [formControlName]="'role'"
                        appendTo="body"
                        [baseZIndex]="1400"
                        panelStyleClass="dept-dropdown-panel"
                        styleClass="dept-form-dropdown"
                        [options]="employee.roles"
                        optionLabel="name"
                        optionValue="value"
                        [placeholder]="'select_role' | translate">
                      </p-dropdown>
                    </div>
                  </div>
                }
              </div>
              <button type="submit" class="dept-btn dept-btn--primary submit-transfer-btn">
                <i class="fa-solid fa-right-left"></i>
                <span>{{ 'transfer_employees' | translate }}</span>
              </button>
            </form>
          </div>
        }

        @if (isEmployeeDeletable && employees.length === 0) {
          <div class="confirm-delete-section">
            <div class="delete-icon">
              <i class="fa-solid fa-trash-can"></i>
            </div>
            <p class="confirm-message">{{ 'confirm_delete_department' | translate }}</p>
            <div class="action-buttons">
              <button type="button" class="dept-btn dept-btn--ghost" (click)="closeDeleteModal()">
                {{ 'cancel' | translate }}
              </button>
              <button type="button" class="dept-btn dept-btn--danger" (click)="confirmDepartmentDelete($event, selectedDepartmentId)">
                <i class="fa-solid fa-trash-can"></i>
                <span>{{ 'confirm_delete' | translate }}</span>
              </button>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}

<p-confirmPopup></p-confirmPopup>
